'use client';

import { c as _c } from "react/compiler-runtime";
import { ChevronRightIcon } from '@heroicons/react/24/outline';
import { usePathname } from 'next/navigation';
import { Container } from '@src/components/Container/Container';
import { LocalizedLink } from '@src/components/LocalizedLink/LocalizedLink';
import { useTopNav } from '@src/components/TopNavV4/TopNavContext';
import { TopNavTile } from '@src/components/TopNavV4/TopNavTile';
import { getUnlocalizedPath } from '@src/i18n/locale.util';
import { useTrackSelectNavCta } from '@src/utils/analytics.util';
import { cn } from '@src/utils/tailwind';
export const TopNavDesktopSlidingPanel = () => {
  const $ = _c(46);
  const trackSelectNavCta = useTrackSelectNavCta();
  const pathname = usePathname();
  const {
    setExpanded,
    expandedMenu,
    isExpanded
  } = useTopNav();
  let t0;
  if ($[0] !== pathname) {
    t0 = function isCurrentPage(t1) {
      const href = t1 === undefined ? "/" : t1;
      ;
      try {
        const linkUrl = new URL(href, window.location.origin);
        return linkUrl.pathname === getUnlocalizedPath(pathname);
      } catch (t2) {
        return false;
      }
    };
    $[0] = pathname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const isCurrentPage = t0;
  let t1;
  if ($[2] !== expandedMenu?.subItems || $[3] !== isCurrentPage || $[4] !== setExpanded || $[5] !== trackSelectNavCta) {
    t1 = () => expandedMenu?.subItems?.filter(_temp).map((subItem_0, index) => <div key={index}><div className="mb-2 text-body-md font-medium">{subItem_0.href ? <LocalizedLink onClick={() => {
          trackSelectNavCta({
            "cta url": subItem_0?.href
          });
          if (isCurrentPage(subItem_0.href)) {
            setExpanded(false);
          }
        }} className="inline-block hover:underline" href={subItem_0.href} rel={subItem_0.newTab ? "noopener noreferrer" : ""} target={subItem_0.newTab ? "_blank" : "_self"}>{subItem_0.title}</LocalizedLink> : <div>{subItem_0.title}</div>}</div><div className="flex flex-col gap-1">{subItem_0.links?.filter(_temp2).map(link_0 => <LocalizedLink onClick={() => {
          trackSelectNavCta({
            "cta url": link_0?.href
          });
          if (isCurrentPage(link_0.href)) {
            setExpanded(false);
          }
        }} className="flex items-center gap-1 rounded-md font-medium text-bodi-gray-butters transition-all hover:text-bodi-white hover:underline" key={link_0.title} href={link_0.href ?? ""} rel={link_0.newTab ? "noopener noreferrer" : ""} target={link_0.newTab ? "_blank" : "_self"}>{link_0.title}{link_0.stamp && <>{" - "}<span className="text-body-sm font-medium text-bodi-accent-bright-500">{link_0.stamp}</span></>}</LocalizedLink>)}</div></div>);
    $[2] = expandedMenu?.subItems;
    $[3] = isCurrentPage;
    $[4] = setExpanded;
    $[5] = trackSelectNavCta;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const renderSubItems = t1;
  let t2;
  if ($[7] !== expandedMenu?.tiles) {
    t2 = () => {
      const tiles = (expandedMenu?.tiles ?? []).filter(_temp3);
      if (tiles.length < 1) {
        return null;
      }
      return tiles?.map(_temp4);
    };
    $[7] = expandedMenu?.tiles;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const renderTiles = t2;
  const numItems = expandedMenu?.subItems?.length ?? 0;
  const numTiles = expandedMenu?.tiles?.length ?? 0;
  let t3;
  if ($[9] !== setExpanded) {
    t3 = () => setExpanded(false);
    $[9] = setExpanded;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const t4 = !isExpanded;
  let t5;
  if ($[11] !== isExpanded || $[12] !== t4) {
    t5 = cn("absolute top-full left-0 z-40 w-full border-t border-bodi-gray-dark bg-bodi-black-text bg-linear-to-t from-white/10 to-white/0 py-6 text-white transition-all duration-200", {
      "translate-y-0": isExpanded,
      "-translate-y-full": t4
    });
    $[11] = isExpanded;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== expandedMenu?.ctaDesktop?.href || $[15] !== expandedMenu?.ctaDesktop?.newTab || $[16] !== expandedMenu?.ctaDesktop?.title || $[17] !== trackSelectNavCta) {
    t6 = expandedMenu?.ctaDesktop?.title && <div className="text-heading-display-3 mb-6 inline-flex items-center gap-2">{expandedMenu?.ctaDesktop?.href ? <LocalizedLink className="hover:underline" href={expandedMenu?.ctaDesktop?.href ?? ""} rel={expandedMenu?.ctaDesktop?.newTab ? "noopener noreferrer" : ""} target={expandedMenu?.ctaDesktop?.newTab ? "_blank" : "_self"} onClick={() => {
        trackSelectNavCta({
          "cta url": expandedMenu?.ctaDesktop?.href
        });
      }}>{expandedMenu?.ctaDesktop?.title}</LocalizedLink> : <div>{expandedMenu?.ctaDesktop?.title}</div>}<ChevronRightIcon className="size-5 text-bodi-accent-bright-500" /></div>;
    $[14] = expandedMenu?.ctaDesktop?.href;
    $[15] = expandedMenu?.ctaDesktop?.newTab;
    $[16] = expandedMenu?.ctaDesktop?.title;
    $[17] = trackSelectNavCta;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  const t7 = numTiles === 2 && numItems > 4 || numTiles < 2;
  const t8 = numTiles === 2 && numItems <= 4;
  const t9 = numTiles === 0;
  let t10;
  if ($[19] !== t7 || $[20] !== t8 || $[21] !== t9) {
    t10 = cn("grid grid-cols-subgrid gap-8", {
      "col-span-3": t7,
      "col-span-2": t8,
      "col-span-4": t9
    });
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== renderSubItems) {
    t11 = renderSubItems();
    $[23] = renderSubItems;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t10 || $[26] !== t11) {
    t12 = <div className={t10}>{t11}</div>;
    $[25] = t10;
    $[26] = t11;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  const t13 = numTiles === 2 && numItems <= 4;
  const t14 = numTiles === 0;
  let t15;
  if ($[28] !== t13 || $[29] !== t14) {
    t15 = cn("grid grid-cols-subgrid gap-8", {
      "col-span-2": t13,
      hidden: t14
    });
    $[28] = t13;
    $[29] = t14;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== renderTiles) {
    t16 = renderTiles();
    $[31] = renderTiles;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t15 || $[34] !== t16) {
    t17 = <div className={t15}>{t16}</div>;
    $[33] = t15;
    $[34] = t16;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== t12 || $[37] !== t17) {
    t18 = <div className="grid w-full grid-cols-4 gap-10">{t12}{t17}</div>;
    $[36] = t12;
    $[37] = t17;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== t18 || $[40] !== t6) {
    t19 = <Container>{t6}{t18}</Container>;
    $[39] = t18;
    $[40] = t6;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  let t20;
  if ($[42] !== t19 || $[43] !== t3 || $[44] !== t5) {
    t20 = <div onMouseLeave={t3} className={t5}>{t19}</div>;
    $[42] = t19;
    $[43] = t3;
    $[44] = t5;
    $[45] = t20;
  } else {
    t20 = $[45];
  }
  return t20;
};
function _temp(subItem) {
  return Boolean(subItem.title);
}
function _temp2(link) {
  return Boolean(link.title);
}
function _temp3(tile) {
  return tile.isVisible ?? true;
}
function _temp4(tile_0, i) {
  return <TopNavTile tile={tile_0} key={i} />;
}